import { render, staticRenderFns } from "./PackagePriceSetting.vue?vue&type=template&id=4f2a29bb"
import script from "./PackagePriceSetting.vue?vue&type=script&lang=js"
export * from "./PackagePriceSetting.vue?vue&type=script&lang=js"
import style0 from "./PackagePriceSetting.vue?vue&type=style&index=0&id=4f2a29bb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports